export function formatDataItaliano(dateString) {
    const date = new Date(dateString);
    const formatter = new Intl.DateTimeFormat('it-IT', {
        weekday: 'long',   // giovedì
        day: '2-digit',    // 03
        month: 'long',     // marzo
        year: 'numeric'    // 2025
    });

    // Prima lettera maiuscola (opzionale)
    const formatted = formatter.format(date);
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
}

export function formatDataItalianoConOra(dateString) {
    const date = new Date(dateString);

    // Formato data
    const dateFormatter = new Intl.DateTimeFormat('it-IT', {
        weekday: 'long',   // giovedì
        day: '2-digit',    // 03
        month: 'long',     // marzo
        year: 'numeric'    // 2025
    });

    // Formato ora
    const timeFormatter = new Intl.DateTimeFormat('it-IT', {
        hour: '2-digit',   // 14
        minute: '2-digit', // 30
        second: '2-digit', // 45
        hour12: false      // formato 24h
    });

    const formattedDate = dateFormatter.format(date);
    const formattedTime = timeFormatter.format(date);

    // Prima lettera maiuscola per la data
    const finalDate = formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);

    return `${finalDate} ${formattedTime}`;
}

export function formatDataToolbar(dateString) {
    const date = new Date(dateString);

    const weekdayFormatter = new Intl.DateTimeFormat('it-IT', {
        weekday: 'long'
    });

    const dateFormatter = new Intl.DateTimeFormat('it-IT', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
    });

    const weekday = weekdayFormatter.format(date).toUpperCase();
    const dateStr = dateFormatter.format(date);
    const finalDate = dateStr.charAt(0).toUpperCase() + dateStr.slice(1);

    return { weekday, date: finalDate };
}

export function formatOra(dateString) {
    const date = new Date(dateString);

    const timeFormatter = new Intl.DateTimeFormat('it-IT', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    });

    return timeFormatter.format(date);
}
